<template>
  <CModal
    :title="$t('audience-new.match-columns.key-column.modal.title')"
    size="xl"
    :show.sync="isOpenModal"
    centered
    :closeOnBackdrop="false"
    @update:show="emitShowUpdated"
  >
    <template slot="body-wrapper" style="min-width: 800px">
      <div class="m-5">
        <p class="font-weight-semi-bold font-xl">{{ $t('audience-new.match-columns.key-column.modal.description') }}</p>
        <SenditTable class="max-h-300 overflow-auto" :headers="tableHeaders" :registers="tableRegisters" :customClassesTable="['--overflow-hidden']">
          <template #matchColumn="props">
            <td class="vertical-middle">
              {{ getSingleLabelValue(props.item.type) }}
            </td>
          </template>
          <template #isKey="props">
            <td class="vertical-middle text-center">
              <CInputCheckbox
                custom
                :checked="props.item.isKey"
                :disabled="hasAnyAudienceKeyOnImport"
                @update:checked="setColumnAsKey($event, props.item)"
              />
            </td>
          </template>
        </SenditTable>
        <div class="mt-3 mb-5 d-flex align-items-baseline font-sm">
          <div>
            <CIcon name="infoCircle" size="custom-size" class="mr-2" :height="16" style="transform: rotate(180deg)" viewBox="0 0 32 32" />
          </div>
          <p class="mb-0 max-w-790">{{ $t('audience-new.match-columns.key-column.modal.info') }}</p>
        </div>
      </div>
    </template>
    <template slot="footer-wrapper">
      <div class="d-flex justify-content-end">
        <CButton class="px-5 py-3" color="primary" @click="setKeyColumns()">
          {{ $t('audience-new.match-columns.key-column.button.confirm') }}
        </CButton>
      </div>
    </template>
  </CModal>
</template>

<script>
import SenditTable from '@/components/table/SenditTable.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'KeyColumnModal',
  components: { SenditTable },
  props: {},
  data() {
    return {
      isOpenModal: false,
      keyColumns: [],
    }
  },
  computed: {
    ...mapGetters({
      hasAnyAudienceKeyOnImport: 'audience/hasAnyAudienceKeyOnImport',
    }),
    tableHeaders() {
      return [
        {
          key: 'fileColumnName',
          label: this.$t('audience-new.match-columns.table.header.col-header'),
          sorter: false,
        },
        { key: 'matchColumn', label: this.$t('audience-new.match-columns.table.header.columns-matched'), sorter: false },
        { key: 'isKey', label: this.$t('audience-new.match-columns.table.header.key-column'), sorter: false, _classes: 'text-center' },
      ]
    },
    tableRegisters() {
      const registersData = this.$store.state.audience.importContacts.importedData?.items

      if (!registersData) return []

      return registersData
        .filter((register) => register.state.key !== 3 /* Não lista colunas ignoradas */)
        .map((register) => {
          return {
            ...register,
            lines: register.lines.join(', '),
          }
        })
    },
  },
  methods: {
    openModal() {
      this.isOpenModal = true
    },
    closeModal() {
      this.isOpenModal = false
    },
    getSingleLabelValue(item) {
      if (!item?.value || !item?.dataType.value) return

      return `${item.value} (${item.dataType.value})`
    },
    emitShowUpdated(value) {
      this.$emit('showUpdated', value)
    },
    setColumnAsKey(isKey, row) {
      if (isKey) {
        this.keyColumns = [...this.keyColumns, { fileColumnPosition: row.fileColumnPosition, isKey: isKey }]
        return
      }

      this.keyColumns = this.keyColumns.filter((keyColumn) => keyColumn.fileColumnPosition !== row.fileColumnPosition)
    },
    setKeyColumns() {
      this.tableRegisters.forEach((register) => {
        const matchedKeyColumn = this.keyColumns.find((keyColumn) => keyColumn.fileColumnPosition === register.fileColumnPosition)

        this.$store.dispatch('audience/setColumnAsKey', {
          position: register.fileColumnPosition,
          isKey: matchedKeyColumn ? matchedKeyColumn.isKey : false,
        })
      })
      this.closeModal()
    },
  },
}
</script>

<style lang="scss" scoped>
.overflow-auto {
  overflow: auto;
}
.max-h-300 {
  max-height: 300px;
}
</style>

<style lang="scss">
.max-w-790 {
  max-width: 780px;
}
</style>
